import { hot } from 'react-hot-loader/root';
import { BrowserRouter } from 'react-router-dom';

import App from './shared/pages/App';
import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';
import { ErrorPage } from './shared/components/Widgets/ErrorPage';
import { getErrorPageTextProps } from './shared/utils/getErrorPageTextProps';

const LeasingApp = () => (
  <RpErrorBoundary
    fallback={
      <ErrorPage errorMessage="Something went wrong" errorDetails="Could not load your lease, try again later." />
    }
    {...getErrorPageTextProps()}
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </RpErrorBoundary>
);

export default hot(LeasingApp);
